import { localDayBounds } from "../../../lib/days";

/**
 * True when an availability mark occupies a SINGLE local day — i.e. it ends on
 * or before the next local midnight after its start day, evaluated in the mark's
 * own zone (`tzid`, default UTC). DST-safe: a fall-back day is 25h and a
 * spring-forward day 23h, so a full-day mark is still single-day (the old
 * "duration <= 24h" heuristic mis-classified a 25h full day as multi-day), and a
 * short mark that crosses local midnight is correctly multi-day. Gates the
 * single-day resize clamp in AvailabilityPage.
 *
 * @param {{startUtc?: any, endUtc?: any, tzid?: string}} mark
 * @returns {boolean}
 */
export function isSingleDayMark(mark) {
  if (!mark?.startUtc || !mark?.endUtc) return false;
  const bounds = localDayBounds(new Date(mark.startUtc), mark.tzid || "UTC");
  if (!bounds) return false;
  return new Date(mark.endUtc).getTime() <= bounds.dayEnd.getTime();
}
